export default class VerificationModalController {
  constructor(component) {
    this.component = component;
  }

  resetForDisplay(styles) {
    const {
      radioButtons,
      suggestedAddressText,
      noMatchText,
      correctAddressText
    } = this.component;

    radioButtons.forEach((radio) => {
      radio.hidden = false;
      radio.checked = false;
    });
    suggestedAddressText.hidden = true;
    noMatchText.hidden = true;
    correctAddressText.hidden = true;
    this.component.buttonWrapper.classList.remove(styles.reverse);
    this.component.continueButton.disabled = true;
  }

  getVerificationOptions() {
    return this.component.modal?.querySelectorAll("[verify-option]") || [];
  }

  getAddressOptions() {
    return this.component.modal?.querySelectorAll("[suggestedAddress]") || [];
  }

  getVisibleOptions() {
    return Array.from(this.getVerificationOptions()).filter(
      (option) => !option.hidden
    );
  }

  getVisibleRadioButtons() {
    return Array.from(this.component.radioButtons).filter(
      (radio) => !radio.hidden
    );
  }

  bindActions({ onEdit, onClose, onContinue, onBackdropClose }) {
    const modalContainer = this.component.modalCloseBtn?.closest(
      '[data-type="modal"]'
    );

    if (modalContainer) {
      modalContainer.onclick = (event) => {
        if (event.target === modalContainer) {
          onBackdropClose?.();
        }
      };
    }

    if (this.component.editButton) {
      this.component.editButton.onclick = onEdit || null;
    }
    if (this.component.modalCloseBtn) {
      this.component.modalCloseBtn.onclick = onClose || null;
    }
    if (this.component.continueButton) {
      this.component.continueButton.onclick = onContinue || null;
    }
  }
}
